import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActionSheetController } from '@ionic/angular';
import { Contract, Data } from '@mlc/types';
import { TranslocoService } from '@ngneat/transloco';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { RequestTypeEnum } from 'src/app/core/models/enums/requestType.enum';
import { RequestService } from 'src/app/core/services/request/request.service';
import { ContractService } from 'src/app/core/services/wallet/wallet.service';

@Component({
  selector: 'app-form-modal',
  templateUrl: './form-modal.component.html',
  styleUrls: ['./form-modal.component.scss'],
  standalone: false,
})
export class FormModalComponent {

  @Input({ required: true }) title!: string;
  @Input({ required: true }) fields: FormlyFieldConfig[] = [];
  @Input({ required: true }) model: any = {};
  @Input({ required: true }) options: any = {};
  @Input({ required: true }) contract!: Data<Contract>;
  @Input({ required: true }) requestType!: RequestTypeEnum;
  @Input({ required: true }) isModalOpen: boolean = false;
  @Output() isModalOpenChange = new EventEmitter<boolean>();

  public form: FormGroup<{}> = new FormGroup({});
  public busy: boolean = false;
  public errorMessage!: string; 

  onClose() {
    this.isModalOpen = false;
    this.isModalOpenChange.emit(this.isModalOpen);
  }

  constructor(
    private actionSheetCtrl: ActionSheetController, 
    private requestService: RequestService,
    private translocoService: TranslocoService,
    private contractService: ContractService
  ) {}

  ngOnInit() {}

  onSubmit() {
    this.busy = true;
    if (this.form.valid) {
      this.requestService.processRequest(this.model, this.contract, this.fields, this.requestType)
      .subscribe({
        next: () => {
          this.contractService.reload();
          this.onClose();
          this.busy = false;
        },
        error: (err: Error) => {
          this.errorMessage = err.message;
          this.busy = false;
        }
      })
    } else {
      this.busy = false;
    }
  }

  async confirmClose() {
    const actionSheet = await this.actionSheetCtrl.create({
    header: this.translocoService.translate('FORM.CLOSE_CONFIRM.TITLE'),
    subHeader: this.translocoService.translate('FORM.CLOSE_CONFIRM.SUBTITLE'),
    buttons: [
      {
        text: this.translocoService.translate('FORM.CLOSE_CONFIRM.CONFIRM'),
        role: 'destructive',
        icon: 'trash-outline',
        handler: () => this.onClose(),
      },
      {
        text: this.translocoService.translate('FORM.CLOSE_CONFIRM.CANCEL'),
        role: 'cancel',
        icon: 'close',
      },
    ]
    });

    await actionSheet.present();
  }
}